module.exports = __webpack_public_path__ + "img/2022_FR.f94dc466.jpg";